export default {
  list: 'https://us-central1-bluefaucet2020.cloudfunctions.net/list',
  status: 'https://us-central1-bluefaucet2020.cloudfunctions.net/status',
  del: 'https://us-central1-bluefaucet2020.cloudfunctions.net/del',
  update: 'https://us-central1-bluefaucet2020.cloudfunctions.net/update'
}